export default __webpack_public_path__ + "static/media/wave.dc060413.svg";